import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-setting-column-table",
  templateUrl: "./setting-column-table.component.html",
  styleUrls: ["./setting-column-table.component.scss"],
})
export class SettingColumnTableComponent implements OnInit, OnChanges {
  @Output() eventSelectedColumns = new EventEmitter<any>();
  @Input() listColumns: any[] = [];
  @Input() selectedColumns: any[] = [];
  listColumnsCurrent: any[] = [];
  isMobile: boolean;
  isTabView: boolean;

  constructor(private modalService: NgbModal) {
    this.isMobile = window.matchMedia("(max-width: 767px)").matches;
    this.isTabView = window.matchMedia("(max-width: 1000px)").matches;
  }

  ngOnInit(): void {}

  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.isMobile = window.matchMedia("(max-width: 767px)").matches;
    this.isTabView = window.matchMedia("(max-width: 1000px)").matches;
  }

  ngOnChanges(): void {
    this.listColumnsCurrent = JSON.parse(JSON.stringify(this.listColumns));
  }

  getColumnsCurrent() {
    localStorage.removeItem("columnsCurrent");
    const columnsCurrent = this.listColumnsCurrent;
    localStorage.setItem("columnsCurrent", JSON.stringify(columnsCurrent));
  }

  save() {
    this.listColumns = JSON.parse(JSON.stringify(this.listColumnsCurrent));
    this.getColumnsCurrent();
    this.modalService.dismissAll();
    const columnsCurrent = JSON.parse(
      <string>localStorage.getItem("columnsCurrent")
    );
    this.eventSelectedColumns.emit(columnsCurrent);
  }

  changesSelectedTableParameters(i: number, j: number) {
    if (this.listColumnsCurrent[i].items[j].default === 1) {
      this.listColumnsCurrent[i].items[j].default = 0;
    } else {
      this.listColumnsCurrent[i].items[j].default = 1;
    }
  }

  onMouseEnter(icon: any) {
    icon.iconColor = "#FFFFFF";
    icon.color = "#308DE3";
  }

  onMouseLeave(icon: any) {
    icon.iconColor = "#308DE3";
    icon.color = "#2E2E2E";
  }

  openModal(content: TemplateRef<any>) {
    this.modalService.open(content, { scrollable: true, size: "lg" });
    this.listColumnsCurrent = JSON.parse(JSON.stringify(this.listColumns));
  }
}
